import { SelectionModel } from "@angular/cdk/collections";
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { combineLatest, forkJoin, Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { BaseApiService } from "../../services/shared/base-api.service";
import { HelpersService } from "../../services/shared/helper.service";
import { HttpQuery } from "../../services/shared/http-query";
import { CheckSelect } from "./check-select";
import { ProgressBarService } from "../../services/shared/progress-bar.service";
import { MatPaginator } from "@angular/material/paginator";
import { ConfirmDialogComponent } from "../../admin/component/confirm-dialog/confirm-dialog.component";
import { User } from "src/app/services/api/user";

@Component({
  selector: 'app-base-page',
  template: ``,
})

export class BasePageComponent<T> implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    public helper: HelpersService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public dialog?: MatDialog,
    public service?: BaseApiService<T>,
    public loading?: ProgressBarService
  ) {
    this.selection = new SelectionModel<T>(true, []);
    this.dataSource = new MatTableDataSource<T>([]);
    this.select = new CheckSelect(this.dataSource, this.selection);
    this.q = { page: this.page, limit: this.limit, embed:  this.relation ? this.relation : this.service.query?.embed };
    // this.service.query = this.q
  }

  currentUser: User
  unsubs = new Subject();
  titlePrefix: string;
  pageTitle: string;
  displayedColumns: string[] = [];
  dataTotal = 0;
  dataSource: MatTableDataSource<T>;
  primaryKey: string;
  sortActive: string;
  sortDirection = 'asc';
  subject: string;
  subjectParent: string = null;
  where = {};
  search: string;
  limit = 50;
  page = 1;
  filterName: string;
  q: HttpQuery;
  data: T[];
  selection: SelectionModel<T>;
  select: CheckSelect<T>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  paginationSub = new Subscription();
  searchSub = new Subscription();
  filters = {};
  relation: string;
  pageSizeOption = [5, 10, 20, 50, 100]

  ngOnInit(): void {
    /**
    * Subscribe data change
    */

    this.service.onQueryChange.next(this.q)
    setTimeout(() => {
      const getDataLength = this.service.onDataLengthChanged
      combineLatest([getDataLength])
      .pipe(takeUntil(this.unsubs))
      .subscribe((response) => {
        this.dataTotal = response[0];
      }, err => {
        this.helper.sbError(err)
      })
      this.afterInit();
    });

    // setTimeout(() => {
    //   const getData = this.service.onDataChanged
    //   const getDataLength = this.service.onDataLengthChanged
    //   combineLatest([getData, getDataLength])
    //   .pipe(takeUntil(this.unsubs))
    //   .subscribe({
    //     next: (response) => {
    //       this.data = response[0];
    //       this.dataTotal = response[1];
    //       this.dataSource = new MatTableDataSource(this.data);
    //       this.select = new CheckSelect(this.dataSource, this.selection);
    //       this.afterGetData()
    //     },
    //     error: err => {
    //       this.helper.sbError(err)
    //     }
    //   })
    //   this.afterInit();
    // });

    this.searchSub.add(this.helper.search$.pipe(takeUntil(this.unsubs)).subscribe((val) => this.onSearch(val)));
  }
  onSearch(val){
    // this.search = val;
    // if (this.dataSource) {
    //   this.dataSource.filter = val.trim().toLowerCase();
    // }
    this.q.search={fields: this.search,value:val.trim().toLowerCase()}
    // this.service.getAll(this.q)
    this.getData()
  }

  afterInit(): void {
    /**
    * Trigger
    */
    // if (!this.data) this.service.getAll(this.q);
    if (!this.data) this.service.getAll(this.q).then(data => {
      this.data = data;
      this.dataSource = new MatTableDataSource(data);
      this.select = new CheckSelect(this.dataSource, this.selection!);
    });

  }

  ngAfterViewInit(): void {
    if (this.sort) {
      this.sort.sortChange.subscribe((sort) => {
        this.onSortChange(sort);
      })
    }
  }

  ngOnDestroy(): void {
    this.unsubs.next('');
    this.unsubs.complete();
    if (this.paginationSub) { this.paginationSub.unsubscribe(); }
    if (this.searchSub) { this.searchSub.unsubscribe(); }
    this.select.selection.clear();
    this.q.filter = {}
    // this.service.onQueryChange.next(this.q)
  }

  onPageChange({ pageSize, pageIndex }): void {
    this.q.limit = pageSize;
    this.q.page = pageIndex + 1;
    // this.service.onQueryChange.next(this.q)
    this.getData();
    this.select.selection.clear(); // Important!
  }

  onSortChange({ active, direction }): void {
    this.sortActive = active;
    this.sortDirection = direction;
    this.q.sort = this.helper.parseSort(active, direction);
    // this.service.onQueryChange.next(this.q)
    this.getData();
  }

  add(): void {
    this.router.navigate(['./action'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        m: 'add',
      },
    });
    // this.service.onQueryChange.next(this.q)
  }

  edit(data: T): void {
    this.router.navigate(['./action'], {
      relativeTo: this.activatedRoute,
      queryParams: {
        m: 'edit',
        id: data[this.primaryKey],
      },
      state: {
        data
      }
    });
    // this.service.onQueryChange.next(this.q)
  }

  parseNo(i){
    return i + 1 + ((this.q.page -1) * this.q.limit)
  }

  transformSubject(data): string {
    return `${this.subjectParent ? this.helper.shortIt(data[this.subjectParent][this.subject]) : this.helper.shortIt(data[this.subject])}`;
  }

  assignData(data): void {
    this.dataSource = new MatTableDataSource(data);
    this.select = new CheckSelect(this.dataSource, this.selection);
  }

  afterGetData(): void{
  }

  getData(): void {
    this.service
        .getAll(this.q)
        .then(data => {
          this.assignData(data)
        })
        .catch(err => {
          this.helper.sbError(err);
        })
  }

  afterRemove(): void {
    // custom function after remove event
    // this.service.onQueryChange.next(this.q);
    this.getData();
    this.select.selection.clear(); // Important!
  }
  onDeleteSuccess(data?: string){
    this.afterRemove()
    this.helper.sbSuccess(`${data} deleted`);
  }
  onDeleteFail(err){
    this.afterRemove()
    this.helper.sbError(err.message);
  }
  remove(data: T): void {
    this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
    })
    .afterClosed()
    .subscribe((result) => {
      if (result) {
        this.service
        .removeById(data[this.primaryKey])
        .then(
          () => this.onDeleteSuccess('(' + this.transformSubject(data) + ')'),
          (err) => this.onDeleteFail(err)
        )
      }
    });
  }
  removeAll(): void {
    this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
    })
    .afterClosed()
    .subscribe((result) => {
      if (result) {
        this.service
        .removeAll()
        .then(
          () => this.onDeleteSuccess('all data'),
          (err) => this.onDeleteFail(err)
        )
      }
    });
  }
  deleteSelected(selected: T[]): void {
    if (selected.length > 0) {
      this.dialog
      .open(ConfirmDialogComponent, {
        width: '400px',
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          const deleted = selected.map((i) => {
            return this.service.removeById(i[this.primaryKey]);
          });
          forkJoin(deleted)
          .pipe(takeUntil(this.unsubs))
          .subscribe(
            {
              next: () => this.onDeleteSuccess(`${selected.length} data`),
              error: (err) => this.onDeleteFail(err)
            }
          );
        }
      });
    }
  }
}
